import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './ember-messaging-client.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class EmberMessagingClient extends Component {
  @service messaging;
  @service messagingNavigation;

  <template>
    <div
      id="ember-messaging-client"
      class="{{styles.component}} messaging-client"
      data-test-ember-messaging-client
      ...attributes
    >
      {{#if this.messaging.loadApp.isRunning}}
        <div class="spinner" data-test-loading-spinner>
          {{svgJar "messaging-spinner"}}
        </div>
      {{else if this.messagingNavigation.currentRoute}}
        {{component
          this.messagingNavigation.currentRoute.component
          handler=this.messagingNavigation.currentRoute.handler
        }}
      {{/if}}
    </div>
  </template>
}
